import React from 'react';
import {MasterLayout} from 'layout';
import {TongHopKetQua} from 'modules/thong-ke-bao-cao';

class TongHopKetQuaGQDTCPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <TongHopKetQua type='GIAI_QUYET_TO_CAO'/>
      </MasterLayout>
    );
  }
}

export default TongHopKetQuaGQDTCPage;


// WEBPACK FOOTER //
// ./src/components/pages/thong-ke-bao-cao/TongHopKetQuaGQDTCPage.jsx